module.exports = {
          srcSet: __webpack_public_path__ + "36fe250d2860390a081ad7bea8133544-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "36fe250d2860390a081ad7bea8133544-2336.png",width: 2336,height: 468}],
          src: __webpack_public_path__ + "36fe250d2860390a081ad7bea8133544-2336.png",
          toString:function(){return __webpack_public_path__ + "36fe250d2860390a081ad7bea8133544-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AABCMf0CRDP/MmZU/jxtW/86a1r/SHVj/1mBbv9BcF7+AEIx/wBDMvsAAEEw/Q1MO/9HdGL+Tnln/0BvXf9TfWr/THhl/1F7af4JSTj/AEEw+8SLJQYmdYMpAAAAAElFTkSuQmCC",
          width: 2336,
          height: 468
        }